import styles from './styles.module.css';

type StepProgressProps = {
  step: number;
  totalSteps: number;
};

export default function StepProgress({ step, totalSteps }: StepProgressProps) {
  const progress = Math.min(Math.max((step / totalSteps) * 100, 0), 100);

  return (
    <div className={styles.container}>
      <span className={styles.text}>
        گام {step} از {totalSteps}
      </span>

      <div className={styles.track}>
        <div className={styles.fill} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
